import { Reveal } from "./Reveal";
import { IMAGES, VOLUME_PILLARS, VOLUME_STATS } from "../lib/data";

export const Volume = () => (
  <section id="volume" data-testid="volume-section" className="relative py-20 md:py-32 border-t border-white/5 scroll-mt-24">
    <div className="absolute inset-0">
      <img src={IMAGES.volumeBar} alt="High volume beverage service" className="w-full h-full object-cover opacity-20" />
      <div className="absolute inset-0 bg-black/80" />
    </div>

    <div className="relative z-10 mx-auto max-w-[1400px] px-5 md:px-10">
      <div className="max-w-3xl">
        <Reveal>
          <p className="text-xs uppercase tracking-[0.3em] text-[#D4AF37] mb-5 md:mb-6">Built For Volume</p>
        </Reveal>
        <Reveal delay={0.1}>
          <h2 className="font-display font-black uppercase tracking-tight text-white text-3xl sm:text-4xl md:text-6xl leading-[0.95]">
            Engineered for the rush.
          </h2>
        </Reveal>
        <Reveal delay={0.2}>
          <p className="mt-6 text-base md:text-lg text-white/65 font-light leading-relaxed">
            High-volume events demand systems, not a single bartender. Good Shot deploys trained teams,
            modular bar builds and proven workflows that hold throughput, consistency and presentation on
            every serve — at any venue, in any market.
          </p>
        </Reveal>
      </div>

      <div className="mt-12 md:mt-16 grid md:grid-cols-3 gap-5 md:gap-8">
        {VOLUME_PILLARS.map((p, i) => {
          const Icon = p.icon;
          return (
            <Reveal key={p.title} delay={0.12 * i}>
              <div
                data-testid={`volume-pillar-${i}`}
                className="h-full bg-[#0a0a0a]/85 border border-white/5 hover:border-[#D4AF37]/40 transition-colors duration-500 p-7 md:p-9"
              >
                <Icon className="w-7 h-7 text-[#D4AF37]" strokeWidth={1.4} />
                <h3 className="mt-6 font-display font-bold uppercase tracking-wide text-white text-lg md:text-2xl">{p.title}</h3>
                <p className="mt-3 text-sm md:text-[15px] text-white/55 font-light leading-relaxed">{p.copy}</p>
              </div>
            </Reveal>
          );
        })}
      </div>

      <Reveal delay={0.15}>
        <div data-testid="volume-stats-grid" className="mt-6 md:mt-8 grid grid-cols-2 gap-5 md:gap-6">
          {VOLUME_STATS.map((s, i) => (
            <div
              key={i}
              data-testid={`volume-stat-${i}`}
              className="bg-[#0a0a0a]/85 border border-[#D4AF37]/15 p-6 md:p-10 flex flex-col items-center justify-center text-center min-h-[130px] md:min-h-[180px]"
            >
              <div className="font-display font-black text-[#D4AF37] text-2xl sm:text-3xl md:text-5xl leading-none break-words">{s.value}</div>
              <div className="mt-3 text-[10px] md:text-xs uppercase tracking-[0.2em] text-white/55">{s.label}</div>
            </div>
          ))}
        </div>
      </Reveal>
    </div>
  </section>
);
